import {DomainObject} from 'shared/store';
import { observable, action, makeObservable } from 'mobx';

class FeaturePermission extends DomainObject {
  id;
  name;
  enabled;

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable,
      enabled: observable,
      toggle: action
    });

    this.merge(other);
  }

  toggle() {
    this.enabled = !this.enabled;
  }
}

export default FeaturePermission;
